module.exports = __webpack_public_path__ + "static/media/GUIDE_0009_01.6f03452f.jpg";